/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onRegisterCompleted = /* GraphQL */ `subscription OnRegisterCompleted($registrationId: String!) {
  onRegisterCompleted(registrationId: $registrationId) {
    registrationId
    magicLink
    error
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnRegisterCompletedSubscriptionVariables,
  APITypes.OnRegisterCompletedSubscription
>;
export const onRegisterToMeetingCompleted = /* GraphQL */ `subscription OnRegisterToMeetingCompleted($registrationId: String!) {
  onRegisterToMeetingCompleted(registrationId: $registrationId) {
    registrationId
    registrationResult
    registrantId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnRegisterToMeetingCompletedSubscriptionVariables,
  APITypes.OnRegisterToMeetingCompletedSubscription
>;
export const onCalendarInviteCompleted = /* GraphQL */ `subscription OnCalendarInviteCompleted($registrationId: String!) {
  onCalendarInviteCompleted(registrationId: $registrationId) {
    registrationId
    subscribed
    error
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCalendarInviteCompletedSubscriptionVariables,
  APITypes.OnCalendarInviteCompletedSubscription
>;
